<template>
  <span>
    <span class="file-type" :class="text" :id="idAttr" @mouseover="handleMouseover" @click="handleOpenJobLogs">
      {{text}}
    </span>
    <b-tooltip v-if="isFileDataAvailable" :target="idAttr">
      <div v-html="fileData"></div>
    </b-tooltip>

    <b-modal v-model="openJobLogs" title="FILE LOGS" size="lg">
      <file-jobs-log :file-id="file.id"></file-jobs-log>
      <template v-slot:modal-footer="{ cancel }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.close')}}

          </b-button>
        </div>
      </template>
    </b-modal>

  </span>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import DateTimeMixin from "@/mixins/dateTime";
  import FileJobsLog from "./modal/FileJobsLog";

  export default {
    name: 'file-type-icon',
    components: {FileJobsLog},
    props: ['file'],
    mixins: [DateTimeMixin],
    data() {
      return {
        info: null,
        infoLoaded: false,
        infoRequested: false,
        error: null,
        openJobLogs: false
      }
    },
    computed: {
      ...mapGetters(['getFileTypeInfo']),

      idAttr() {
        return 'file-type-icon-' + this.file.id;
      },

      isFileDataAvailable() {
        return this.file.file_type_id == 1 || this.file.file_type_id == 2;
      },

      fileTypeInfo() {
        return this.getFileTypeInfo(this.file.file_type_id);
      },

      text() {
        return this.fileTypeInfo.name;
      },

      variant() {
        return '-' + this.fileTypeInfo.color;
      },

      fileData() {
        if (!this.isFileDataAvailable) {
          return null;
        }
        if (!this.infoLoaded || this.file.status_id === '8') {
          return this.$t('files.typeTooltip.loading');
        }
        if (this.error) {
          return this.error;
        }
        if (!this.info) {
          return this.$t('files.typeTooltip.unavailable');
        }

        if (this.file.file_type_id == 1) {
          return this.stlFileData(this.info);
        } else {
          return this.gcodeFileData(this.info);
        }
      },
    },
    methods: {
      ...mapActions(['getFileInfo']),

      handleMouseover() {
        if (this.isFileDataAvailable && !this.infoRequested) {
          this.infoRequested = true;
          this.getFileInfo(this.file.id).then(({data}) => {
            this.infoLoaded = true;
            if (data.result) {
              this.info = data.message;
            } else {
              if( data.message === "No information"){
                this.infoRequested = false;
                this.infoLoaded = false;
              }else{
                this.error = data.message;
              }
            }
          });
        }
      },

      handleOpenJobLogs(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.openJobLogs = true;
      },

      stlFileData(fileData) {
        let q = '';
        if(fileData.stl_max_x && fileData.stl_max_y && fileData.stl_max_z){
          q += this.$t('files.typeTooltip.maxDimensions') + ": " + fileData.stl_max_x +"x"+ fileData.stl_max_y +"x"+ fileData.stl_max_z +" " + this.$t('measure.shortcut.millimeter');
        }else{
          q += this.$t('files.typeTooltip.maxDimensions') + ": " +  this.$t('files.typeTooltip.na');
        }
        q += "<br />";

        if(fileData.stl_etc) {
          q += this.$t('files.typeTooltip.modelVolume') + ": ";
          q += JSON.parse(fileData.stl_etc)['m_volume']+" cm<span class='sup'>3</span>";
          q += "<br />";
        }

        return q;
      },

      gcodeFileData(fileInfo) {
        let  q = this.$t('files.typeTooltip.printerType') + ": ";
        q  += (!fileInfo.printer_type_description) ? this.$t('files.typeTooltip.na') : fileInfo.printer_type_description ;
        q  += "<br />";
        q  += this.$t('files.typeTooltip.layerHeight') + ": ";
        q  += (!+fileInfo.layer_height) ? this.$t('files.typeTooltip.na'): Math.round(fileInfo.layer_height*100)/100  + " " + this.$t('measure.shortcut.millimeter') ;
        q  += "<br />";

        let extruders = JSON.parse(fileInfo.extruders);
        if (extruders) {
          extruders.map((i, t) => {
            if (t.t>0) {
              q += 'Extruder '+(+i+1)+' temperature: '+(+t.t)+' C<br />';
            }
          });
        } else {
          q  += this.$t('files.typeTooltip.extruders') + ": " + this.$t('files.typeTooltip.na');
          q  += "<br />";
        }

        q += this.$t('files.typeTooltip.bedTemperature') + ": ";
        q += (fileInfo.heated_bed!='t') ? this.$t('files.typeTooltip.na'): fileInfo.heated_bed_temperature + " C";
        q += "<br />";

        q += this.$t('files.typeTooltip.length') + ": ";
        q += (!+fileInfo.total_extruded) ? this.$t('files.typeTooltip.na'): this.number_format(parseFloat(fileInfo.total_extruded)/1000,3)  + " " + this.$t('measure.shortcut.meter');
        q += "<br />";

        //console.log(extruders)

        q += this.$t('files.typeTooltip.cost') + ": ";
        q += (!+fileInfo.cost) ? this.$t('files.typeTooltip.na'): '$'+this.number_format(parseFloat(fileInfo.cost),2);
        q += "<br />";

        if (extruders && extruders.length  > 1) {
          extruders.map((t,i) => {
            if (t.w>0) {
              q += 'Extruder '+(+i+1)+' weight: '+this.number_format(parseFloat(t.w),2)+' g.<br />';
            } else {
              q += 'Extruder '+(+i+1)+' weight: n/a<br />';
            }
          });
        } else {
          q += this.$t('files.typeTooltip.weight') + ": ";
          //q += (!fileInfo.weight) ? "n/a": number_format(parseFloat(fileInfo.weight)/1000,3)  + " gr.";
          q += (!+fileInfo.weight) ? this.$t('files.typeTooltip.na'): this.number_format(parseFloat(fileInfo.weight),2)  + " " + this.$t('measure.shortcut.gram');
          q += "<br />";
        }

        q += this.$t('files.typeTooltip.estimatedTime') + ": ";
        q += (!+fileInfo.printing_duration) ?  this.$t('files.typeTooltip.na'): this.toHHMMSS(fileInfo.printing_duration) ;
        q += "<br />";

        return q;
      },

      number_format( number, decimals, dec_point, thousands_sep ) {	// Format a number with grouped thousands
        //
        // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
        // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +	 bugfix by: Michael White (http://crestidg.com)

        var i, j, kw, kd, km;

        // input sanitation & defaults
        if( isNaN(decimals = Math.abs(decimals)) ){
          decimals = 2;
        }
        if( dec_point == undefined ){
          dec_point = ",";
        }
        if( thousands_sep == undefined ){
          thousands_sep = ".";
        }

        i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

        if( (j = i.length) > 3 ){
          j = j % 3;
        } else{
          j = 0;
        }

        km = (j ? i.substr(0, j) + thousands_sep : "");
        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
        //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
        kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");


        return km + kw + kd;
      }
    },
  }
</script>
